import { useCallback, useState } from 'react';
import axios from 'axios';

// Download weekly newsletter PDFs with authenticated access
export function useNewsScrollDownload({ instance, loginRequest, fileURL }) {
    const [isDownloading, setIsDownloading] = useState(false);

    const downloadFile = useCallback(async () => {
        try {
            // Ensure the MSAL session is available before downloading
            const activeAccount = instance.getActiveAccount();

            if (!activeAccount) {
                console.warn('No active account. Please log in.');
                return;
            }

            setIsDownloading(true);

            // Request an access token for the protected data API
            const tokenResponse = await instance.acquireTokenSilent({
                ...loginRequest,
                account: activeAccount,
            });

            // Fetch the PDF as a blob for browser opening
            const response = await axios.get(fileURL, {
                responseType: 'blob',
                headers: {
                    Authorization: `Bearer ${tokenResponse.accessToken}`,
                },
                timeout: 60000
            });

            // Convert the response into a browser-openable file
            const blob = new Blob([response.data], { type: response.headers['content-type'] });
            const url = window.URL.createObjectURL(blob);
            window.open(url, '_blank');

            setTimeout(() => window.URL.revokeObjectURL(url), 60000);
        } catch (error) {
            console.error('Error opening the file:', error);
            alert('Failed to open the file. Please try again.');
        } finally {
            setIsDownloading(false);
        }
    }, [fileURL, instance, loginRequest]);

    return { downloadFile, isDownloading };
}
